import { useEffect, useState } from "react";
import axios from "axios";
import { AlertOctagon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ImportanceOneAlert = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/products/order-importance/alerts`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;
  return (
    <Card className="mb-8 border-2 border-red-500 bg-red-50" data-testid="importance-one-alert">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-red-700 text-lg">
          <AlertOctagon className="h-5 w-5" />
          {items.length} very important product{items.length === 1 ? "" : "s"} below re-order level — not on order
        </CardTitle>
        <p className="text-sm text-red-700/80">Importance 1 items with no open purchase order. Order these first.</p>
      </CardHeader>
      <CardContent>
        <div className="max-h-72 overflow-auto rounded border border-red-200 bg-white">
          <table className="w-full text-sm">
            <thead className="bg-red-100 text-red-900 text-xs uppercase sticky top-0">
              <tr>
                <th className="text-left px-3 py-1.5 hidden sm:table-cell">PLU</th>
                <th className="text-left px-3 py-1.5">Product</th>
                <th className="text-right px-3 py-1.5">Stock</th>
                <th className="text-right px-3 py-1.5">Re-order</th>
                <th className="text-left px-3 py-1.5 hidden sm:table-cell">Supplier</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-red-100" data-testid={`importance-one-row-${p.plu_code}`}>
                  <td className="px-3 py-1.5 font-mono hidden sm:table-cell">{p.plu_code}</td>
                  <td className="px-3 py-1.5 font-medium">{p.name}</td>
                  <td className="px-3 py-1.5 text-right font-bold text-red-700">{Number(p.current_stock || 0)}</td>
                  <td className="px-3 py-1.5 text-right">{Number(p.reorder_level || 0)}</td>
                  <td className="px-3 py-1.5 text-gray-600 hidden sm:table-cell">{p.supplier || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};
